import {
  SET_DISABLE_SIDEBAR_COMMENTS,
  UPDATE_SIDEBAR_STATE,
} from '../../actions/returnReasonSidebar';

export const initialState = {
  open: false,
  currentItem: null,
  itemProperties: null,
  itemId: null,
  temporaryItems: {},
  savedItems: {},
  itemQuantity: null,
  eligibleQtyList: null,
  returnQuantity: 0,
  returnReasonCodes: null,
  itemFinalized: false,
  nestedReasons: null,
  selectedReason: null,
  selectedNestedReason: null,
  returnComment: '',
  disableSidebarComments: false,
  commentHidden: null,
  commentRequired: null,
  commentPlaceholder: null,
  photoUploadEnabled: false,
  photoUploadRequired: false,
  photoUploadPlaceholder: '',
  photoUploadTitle: '',
  photoUploadMaxFiles: undefined,
  nestedReasonsTitle: '',
  isExchange: false,
  exchangeEligibility: false,
  disableSubmit: false,
  expiryList: [],
  quantityFieldAction: null,
  validationMessage: '',
  isVerifying: false,
  error: {
    field: null,
    message: null,
  },
};

export default (
  state = initialState,
  { type, data: { disableSidebarComments, sidebarState } = {} } = {},
) => {
  switch (type) {
    case SET_DISABLE_SIDEBAR_COMMENTS:
      return {
        ...initialState,
        disableSidebarComments,
      };

    case UPDATE_SIDEBAR_STATE:
      return {
        ...state,
        ...sidebarState,
      };

    default:
      return state;
  }
};
